<template>
	<!-- BLOCK BACK -->
        <section class="navigation navigation-back d-block d-lg-none">
            <div class="container w-736 p-0 pt-4 px-4">
                <div class="d-flex align-items-center justify-content-start">
                    <i class="mr-3" @click="handleClick">
                        <svg aria-hidden="true" width="16" height="14" title="FPT TELECOM">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-back"></use>
                        </svg>
                    </i>
                    <a class="clo-white" href="javascript:;">{{ title }}</a>
                    <span class="ml-auto clo-white">{{ step }}</span>
                </div>
            </div>
        </section>
</template>

<script>
	export default {
		name: "blockBack",
		methods: {
			handleClick () {
				this.$emit('click-back');
			}
        },
		props: {
			step: {
				type: String,
				required: true
			},
			title: {
				type: String,
				required: true
			}
		}
	};
</script>
